import React from "react";
import { GRID } from "../../constants";
import PropTypes from "prop-types";

export const Grid = ({ 
  children, 
  gap = GRID.gutterWidth, 
  className = "", 
  columns = GRID.columns,
  as: Component = "div",
  ...props 
}) => {
  // Convert columns to responsive Tailwind classes
  const gridColsClass = `grid-cols-1 md:grid-cols-2 lg:grid-cols-${columns}`;
  
  // Convert gap to Tailwind classes with responsive values
  const gapClass = `gap-3 md:gap-4 lg:${gap}`;
  
  return (
    <Component
      className={`grid ${gridColsClass} ${gapClass} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

Grid.propTypes = {
  children: PropTypes.node,
  gap: PropTypes.string,
  className: PropTypes.string,
  columns: PropTypes.number,
  as: PropTypes.elementType
};

export default Grid; 